/**
 * Detect the moved item in an array of objects with unique id
 * Assuming that only one item has been moved
 * @param oldArray array before changing item order
 * @param newArray array after changing item order
 * @returns returns the moved item with old index and new index
 */
export const detectMovedItemInArray = <T extends { id: unknown }>(oldArray: T[], newArray: T[]) => {
  let i = 0;
  let j = oldArray.length - 1;
  while (i < oldArray.length && oldArray[i].id === newArray[i].id) {
    i++;
  }
  while (j >= 0 && oldArray[j].id === newArray[j].id) {
    j--;
  }

  if (i >= j) {
    return null;
  }

  if (oldArray[j].id === newArray[i].id) {
    return { item: oldArray[j], from: j, to: i };
  }

  if (oldArray[i].id === newArray[j].id) {
    return { item: oldArray[i], from: i, to: j };
  }

  return null;
};

/**
 * Checks whether a value is one of the items of a list, narrowing it to the list's item type
 * @param list the allowed values, usually an `as const` array
 * @param value the value to check
 */
export const isOneOf = <T>(list: readonly T[], value: unknown): value is T => list.some((item) => item === value);
